import script from "./ViaggioInterattivoDataDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggioInterattivoDataDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViaggioInterattivoDataDialog.vue?vue&type=style&index=0&id=659489c0&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659489c0"]])

export default __exports__